import Select2BaseColumn from './Select2BaseColumn';
import {odata} from 'linksoft';

export default class EnumColumn extends Select2BaseColumn {

	displayValue(value) {
		const enums = this.api.init().enums;
		const targetEnum = enums && this.options.dataType && enums[this.options.dataType];
		if (targetEnum) {
			const item = targetEnum.find(x => x.id === value || x.value == value);
			if (item) {
				return item.text;
			}
		}
		return value;
	}

	createEditor(value, id) {
		const values = this.column.enumValues();
		const options = values.map(v => `<option value="${v.value}" ${v.value === value ? 'selected="selected"' : ''}>${v.text}</option>`).join('');
		return `<select class="table-input">${options}</select>`;
	}

	createFilter() {
		const values = this.api.init().enums[this.options.dataType] || [];
		const options = values.map(v => `<option value="${v.id}">${v.text}</option>`).join('');
		return (
			`<div class="input-group"><select class="form-control table-filter">
<option value="">${this.getFilterAllText()}</option>${options}</select></div>`
		);
	}

	buildFilterExpression(fieldName, columnFilter) {
		return odata.filters.equals(fieldName, columnFilter);
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/EnumColumn.js